document.addEventListener("DOMContentLoaded", function () {
  let transitionLocked = false;

  const bootScreen = document.querySelector(".boot-screen");
  const mainMenu = document.querySelector(".main-menu");

  if (bootScreen && mainMenu) {
    let bootStarted = false;

    bootScreen.addEventListener("click", function () {
      if (bootStarted) return;

      bootStarted = true;

      bootScreen.classList.add("boot-screen--fade");

      setTimeout(function () {
        bootScreen.style.display = "none";
        mainMenu.classList.add("main-menu--visible");
      }, 800);
    });
  }

  document.addEventListener("click", function (event) {
    const menuButton = event.target.closest("[data-memory-screen]");

    if (!menuButton || transitionLocked) return;

    const screenName = menuButton.dataset.memoryScreen;

    if (
      !["shop", "settings", "archive"].includes(screenName)
    ) {
      return;
    }

    const destinationScreen = document.querySelector(
      "." + screenName + "-screen"
    );

    if (!destinationScreen) return;

    transitionLocked = true;

    mainMenu.classList.add("main-menu--fade");

    setTimeout(function () {
      mainMenu.classList.remove("main-menu--visible");
      mainMenu.classList.remove("main-menu--fade");

      destinationScreen.classList.add(
        screenName + "-screen--visible"
      );

      transitionLocked = false;
    }, 600);
  });

  document.addEventListener("click", function (event) {
    const backButton = event.target.closest(
      ".shop-screen__back, .settings-screen__back, .archive-screen__back"
    );

    if (!backButton || transitionLocked) return;

    const activeScreen = backButton.closest(
      ".shop-screen, .settings-screen, .archive-screen"
    );

    if (!activeScreen) return;

    transitionLocked = true;

    let visibleClass = "";
    let fadeClass = "";

    if (activeScreen.classList.contains("shop-screen")) {
      visibleClass = "shop-screen--visible";
      fadeClass = "shop-screen--fade";
    } else if (activeScreen.classList.contains("settings-screen")) {
      visibleClass = "settings-screen--visible";
      fadeClass = "settings-screen--fade";
    } else {
      visibleClass = "archive-screen--visible";
      fadeClass = "archive-screen--fade";
    }

    activeScreen.classList.add(fadeClass);

    setTimeout(function () {
      activeScreen.classList.remove(visibleClass);
      activeScreen.classList.remove(fadeClass);

      mainMenu.classList.add("main-menu--visible");

      transitionLocked = false;
    }, 600);
  });
});